import { ZoomIn } from "lucide-react";
import React, { useState } from "react";
import { Controlled as ControlledZoom } from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

const ImageZoomWithButton = ({ item, isFabricSelected, customize }) => {
	const [isZoomed, setIsZoomed] = useState(false);

	const handleZoomChange = (shouldZoom) => {
		if (shouldZoom) {
			return;
		}
		setIsZoomed(shouldZoom);
	};

	const handleButtonClick = () => {
		setIsZoomed(true); // Always set zoom to true when button is clicked
	};

	return (
		<div className="relative flex flex-col items-end">
			<ControlledZoom
				zoomMargin={5}
				isZoomed={isZoomed}
				onZoomChange={handleZoomChange} // Controlled state for zoom
			>
				<img
					className="w-full h-auto rounded-md"
					src={item.image.toLowerCase()}
					alt={item.colour}
				/>
			</ControlledZoom>

			<button
				className="absolute bottom-2 right-2"
				onClick={() => handleButtonClick()}
			>
				<ZoomIn className="text-primary" />
			</button>

			{customize && isFabricSelected ? (
				<div className="customCheckbox z-0">
					<span
						style={{
							border: "0px solid #ccc",
							backgroundColor: "transparent",
						}}
						className="checkbox selected"
					>
						<span
							className="checkmark"
							style={{
								width: 15,
								height: 15,
								backgroundSize: "9px 9px",
							}}
						/>
					</span>
				</div>
			) : (
				""
			)}
		</div>
	);
};

export default ImageZoomWithButton;
